/* bandzOn — password page */
(function () {
  const root = document.getElementById('bz-pw');
  if (!root) return;
  const CFG = JSON.parse(document.getElementById('bz-pw-config').textContent);
  const COLORS = CFG.colors.filter((c) => c.img);
  if (!COLORS.length) return;
  const $ = (s) => root.querySelector(s);
  document.body.classList.add('bz-page', 'bz-pw-body');

  let i = 0;
  function apply(c) {
    const vars = { '--bz-bg': c.bg, '--bz-ink': c.ink, '--bz-soft': c.soft, '--bz-panel': c.panel, '--bz-line': c.line, '--bz-logo': c.logo || 'none' };
    for (const [v, val] of Object.entries(vars)) { root.style.setProperty(v, val); document.body.style.setProperty(v, val); }
    root.style.setProperty('--bz-blend', (c.logo === 'invert(1)' ? 'screen' : 'multiply'));
    document.body.classList.add('bz-switching');
    clearTimeout(apply._t); apply._t = setTimeout(() => document.body.classList.remove('bz-switching'), 620);
    root.querySelectorAll('.bz-layer').forEach((l) => l.classList.toggle('on', l.dataset.c === c.k));
    document.body.classList.toggle('bz-night', parseInt(c.bg.replace('#', ''), 16) < 0x333333);
  }
  apply(COLORS[0]);
  if (COLORS.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    setInterval(() => { i = (i + 1) % COLORS.length; apply(COLORS[i]); }, (CFG.rotate || 3) * 1000);
  }

  /* headline wobble */
  const h1 = root.querySelector('h1');
  if (h1 && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const text = h1.textContent.trim();
    h1.textContent = '';
    [...text].forEach((ch, i) => {
      if (ch === ' ') { const s = document.createElement('span'); s.className = 'sp'; h1.appendChild(s); return; }
      const s = document.createElement('span');
      s.className = 'ltr'; s.textContent = ch;
      s.style.setProperty('--d', (i * 0.07).toFixed(2) + 's');
      h1.appendChild(s);
    });
  }

  /* twinkling stars */
  const sky = $('#bz-pw-sky');
  if (sky) { const n = Math.min(70, Math.round(innerWidth * innerHeight / 18000));
    for (let k = 0; k < n; k++) { const s = document.createElement('i'); if (Math.random() < .18) s.className = 'big';
      s.style.cssText = `left:${Math.random()*100}%;top:${Math.random()*100}%;--d:${(2.5+Math.random()*4).toFixed(1)}s;--o:${(Math.random()*5).toFixed(1)}s`; sky.appendChild(s); } }

  /* countdown */
  const box = $('#bz-pw-count');
  if (box && CFG.countdown && CFG.date && /^\d{4}-\d{2}-\d{2}$/.test(CFG.date.trim())) {
    const target = new Date(`${CFG.date}T${CFG.time || '18:00'}:00`);
    if (!isNaN(target)) {
      box.hidden = false;
      const pad = (v) => String(Math.max(0, v)).padStart(2, '0');
      const tick = () => {
        const ms = target - new Date();
        if (ms <= 0) { box.hidden = true; $('#bz-pw-sub').textContent = 'It\u2019s live.'; return; }
        const s = Math.floor(ms / 1000);
        $('#bz-d').textContent = pad(Math.floor(s / 86400));
        $('#bz-h').textContent = pad(Math.floor(s / 3600) % 24);
        $('#bz-m').textContent = pad(Math.floor(s / 60) % 60);
        $('#bz-s').textContent = pad(s % 60);
      };
      tick(); setInterval(tick, 1000);
    }
  }
})();
